<template>
  <div
    style="position: relative;width: 100%;"
    :class="{'open':openSuggestion}"
  >
    <b-form-input
      ref="SearchInput"
      v-model="model"
      type="text"
      :state="state"
      :placeholder="placeholder"
      :class="pluginConfig.class"
      class="search-input"
      autocomplete="off"
      @keydown.enter="enter"
      @input="change"
      @keydown="onKeydown"
      @blur="onBlur"
    />
    <ul
      class="dropdown-menu auto-complete-dropdown"
      style="width:100%"
    >
      <b-dropdown-item
        v-for="(suggestion, index) in matches"
        v-if="openSuggestion"
        :key="index"
        :class="{'active': isActive(index)}"
        @click="suggestionClick(index)"
      >
        <span v-html="getFormattedSuggestion(suggestion)" />
      </b-dropdown-item>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    suggestions: {
      type: Array,
      default: () => [],
    },
    pluginConfig: {
      type: Object,
      default: () => ({
        class: '',
      }),
    },
    value: String,
    state: Boolean,
    focus: Boolean,
    placeholder: {
      type: String,
      default: 'Please enter 3 or more characters for search',
    },
  },
  data() {
    return {
      open: false,
      current: 0,
      model: '',
    };
  },
  computed: {
    matches() {
      return this.suggestions.filter((str) => {
        return str ? str.toLowerCase().indexOf(this.model ? this.model.toLowerCase() : null) >= 0 : null;
      });
    },
    openSuggestion() {
      return this.model && this.model !== '' && this.model.length > 2 && this.matches.length !== 0 && this.open === true;
    },
  },
  methods: {
    enter() {
      this.selection = this.matches[this.current];
      this.open = false;
    },
    isActive(index) {
      return index === this.current;
    },
    change() {
      if (this.open === false) {
        this.open = true;
        this.current = 0;
      }
      this.$emit('input', this.model);
    },
    onKeydown($event) {
      this.$emit('keydown', $event);
    },
    onBlur($event) {
      setTimeout(() => this.$emit('blur', $event), 100);
    },
    suggestionClick(index) {
      this.model = this.matches[index];
      this.change();
      this.open = false;
    },
    getFormattedSuggestion(suggestion) {
      if (!this.matches.length) return suggestion;
      return suggestion.replace(new RegExp(`(${this.model})`, 'i'), '<span style="color:#fc0000;">$1</span>');
    },
    setFocus() {
      let i = 0;
      const interval = setInterval(() => {
        if (i >= 300) {
          clearInterval(interval);
          i = 0;
        }
        this.$refs.SearchInput ? this.$refs.SearchInput.focus() : null;
        if (document.activeElement.classList.contains('search-input')) {
          clearInterval(interval);
        }
        i++;
      }, 100);
    },
    prepareData() {
      this.model = this.value;
      if (this.focus) this.setFocus();
    },
    setEventListeners() {
      document.addEventListener('click', (event) => {
        if (!event.target.closest('.auto-complete-dropdown')) {
          this.open = false;
        }
      });
    },
  },
  mounted() {
    this.prepareData();
    this.setEventListeners();
  },
};
</script>

<style lang="scss" scoped>
.open {
  .dropdown-menu {
    display: block;
    overflow: auto;
  }
}
</style>